



























































import { Component, Vue } from 'vue-property-decorator';
import { getRole } from '@/utils/cookie';
import { UserRole } from '@/resource/user/user.model';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import LoadingBox from '@/components/common/LoadingBox.vue';
import { getAllBlogs } from '@/utils/blogs/add-blog/add-blog-util';

@Component({
  components: { VueGoodTable, LoadingBox },
})
export default class AdminBlogs extends Vue {
  columns = [
    {
      label: 'id',
      field: 'id',
      type: 'number',
    },
    {
      label: 'Title',
      field: 'title',
    },

    {
      label: 'Duration',
      field: 'duration',
    },
    {
      label: 'Created At',
      field: 'createdAt',
    },
    {
      label: 'Published At',
      field: 'publishedAt',
    },
    {
      label: 'User',
      field: 'user',
    },
    {
      label: 'Publish By',
      field: 'publishBy',
    },
    {
      label: 'Order',
      field: 'order',
    },
    {
      label: 'View',
      field: 'uuid',
    },
    {
      label: 'Edit',
      field: 'uuid',
    },
  ];

  totalUsers = 0;
  rows: any[] = [];

  total = this.rows.length;
  isLoading = true;

  get userRole(): UserRole | null {
    return getRole();
  }

  onSearch(params: any) {
    this.total = params.rowCount;
  }

  async created() {
    await this.fetchBlogs();
  }

  async fetchBlogs() {
    this.isLoading = true;
    const blogs = await getAllBlogs();
    this.rows = blogs.map(blog => {
      return {
        id: blog.id,
        uuid: blog.uuid,
        title: blog.title,
        duration: blog.duration,
        createdAt: this.$dayjs(blog.createdAt).format('HH:mm DD/MM/YYYY'),
        publishedAt: blog.publishedAt
          ? this.$dayjs(blog.publishedAt).format('HH:mm DD/MM/YYYY')
          : 'None',
        user: blog.user?.firstName ? blog.user?.firstName : 'None',
        publishBy: blog.publishBy?.firstName
          ? blog.publishBy?.firstName
          : 'None',
        order: blog.order,
      };
    });
    this.total = this.rows.length;

    this.isLoading = false;
  }
}
